import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=507f22fd&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
import style0 from "./Language.vue?vue&type=style&index=0&id=507f22fd&prod&lang=scss&scoped=true"
import style1 from "./Language.vue?vue&type=style&index=1&id=507f22fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f22fd",
  null
  
)

export default component.exports